module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-216.3713e366.svg";